import { format } from 'date-fns'
import * as React from 'react'
import 'react-day-picker/lib/style.css'
import Calendar from '../icons/ui/Calendar'
import CheckMarker from '../icons/ui/CheckMarker'
import SelectDate from './SelectDate'

export interface ILimitedTime {
  isOpen: boolean
  onToggle: () => void
  onSetDateData: (dateData: any) => void
  handleSetValue: (value: string) => void
}

class LimitedTime extends React.Component<ILimitedTime, any> {
  constructor(props: ILimitedTime) {
    super(props)
    this.state = {
      startDateCalendar: false,
      endDateCalendar: false,
      startDate: new Date(),
      endDate: ''
    }
  }

  public selector = () => (
    <div className='mt1'>
      <span className='col-10 mr1 ml2 h6 font-dark-grey'>Start date/time</span>
      <div className='flex items-center'>
        <div className='border-light-grey4 bg-white rounded col-10 ml2'>
          <input
            placeholder='MM / DD / YY  HH:MM am'
            type='text'
            className='border-none center border-none input-placeholder-h6 uppercase'
          />
        </div>
        <Calendar className='ml1 icon--20x20 cursor--pointer' />
      </div>
    </div>
  )

  public openSelectDate = (key: string) => () => {
    this.setState({ [key]: true })
  }

  public closeSelectDate = (key: string) => () => {
    this.setState({ [key]: false })
  }

  public handleApply = () => {
    console.log('handleApply')
  }

  public handleDayClick = (key: string) => (selectedDay: any, modifiers: any) =>
    !modifiers.disabled && this.setState({ [key]: selectedDay })

  public formatSelectedDateTime = (date: string, time: string) => {
    return format(date, 'MM / DD / YY') + ' ' + format(time, 'HH:mm a')
  }

  public render() {
    return (
      <div>
        <div className='flex flex-wrap items-center'>
          <div
            className='border-grey5 bg-white icon--small rounded cursor--pointer justify-center flex'
            onClick={this.props.onToggle}
          >
            {this.props.isOpen && <CheckMarker className='check-marker' />}
          </div>
          <span className='col-10 mr1 ml1 h6 font-dark-grey'>Limited Time</span>
          {this.props.isOpen && (
            <div>
              <div className='pl1'>
                <div className='mt1'>
                  <span className='col-10 mr1 ml2 h6 font-dark-grey'>Start date/time</span>
                  <div className='flex items-center relative'>
                    <div className='border-light-grey4 bg-white rounded col-10 ml2'>
                      <input
                        placeholder='MM / DD / YY  HH:MM am'
                        type='text'
                        className='border-none center border-none input-placeholder-h6 uppercase'
                        value={this.formatSelectedDateTime(this.state.startDate, '1')}
                      />
                    </div>
                    <div onClick={this.openSelectDate('startDateCalendar')}>
                      <Calendar className='ml1 icon--20x20 cursor--pointer' />
                    </div>
                    {this.state.startDateCalendar && (
                      <SelectDate
                        title='Start'
                        handleClose={this.closeSelectDate('startDateCalendar')}
                        handleDayClick={this.handleDayClick('startDate')}
                        selectedDay={this.state.startDate}
                        handleApply={this.handleApply}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className='pl1'>
                <div className='mt1'>
                  <span className='col-10 mr1 ml2 h6 font-dark-grey'>End date/time*</span>
                  <div className='flex items-center relative'>
                    <div className='border-light-grey4 bg-white rounded col-10 ml2'>
                      <input
                        placeholder='MM / DD / YY  HH:MM am'
                        type='text'
                        className='border-none center border-none input-placeholder-h6 uppercase'
                        value={this.state.endDate ? this.state.endDate : ''}
                      />
                    </div>
                    <div onClick={this.openSelectDate('endDateCalendar')}>
                      <Calendar className='ml1 icon--20x20 cursor--pointer' />
                    </div>
                    {this.state.endDateCalendar && (
                      <SelectDate
                        title='End'
                        handleClose={this.closeSelectDate('endDateCalendar')}
                        handleDayClick={this.handleDayClick('endDate')}
                        selectedDay={this.state.endDate}
                        handleApply={this.handleApply}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default LimitedTime



// WEBPACK FOOTER //
// ./src/components/membership-request/LimitedTime.tsx